import scanComplete from './../../scan-complete.svg';
function Scan() {
    return (
        <>
            <div className='mt-5 mb-10 font-inter text-2xl font-bold leading-[32.5px]" text-white w-full'>
                <div className='flex flex-col justify-evenly items-center'>
                    <img src={scanComplete} alt="scancomplete" />

                    <br />
                    <p>
                        Looking good.
                    </p>
                </div>
            </div>
        </>
    )
}
export default Scan;


